import React from "react";
import {Text, Image, useColorModeValue, Flex, Box} from "@chakra-ui/react";
import Link from "./Link";
import theme from "./Theme/Theme";
// import NewWindow from 'react-new-window';
// import AppLink from 'react-native-app-link';
import OpenApp from "react-open-app";


function MenuCard(props) {
    let boxBg = useColorModeValue("white !important", "#111c44 !important");
    let mainText = useColorModeValue("#565E6D");
    let secondaryText = useColorModeValue("gray.600", "gray.600");
    let BgdisableColor = useColorModeValue("rgba(150, 150, 150, 0.2)");
    let TextdisableColor = useColorModeValue("gray.400", "gray.400");
    const engfont = 'IBM Plex Sans'
	return (
        <>
            {/* <OpenApp href={props.link}> */}
             <Link to={props.activate ? props.link : window.location.href} onClick={props.onClick}> 
            {/* <NewWindow url={props.link}> */}
            <Box borderRadius='20px' boxShadow={'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}>
            <Flex
                borderRadius='20px'
                bg={props.activate ? boxBg : BgdisableColor}
                w='175px'
                h='78px'
                alignItems='center'
                justifyContent={'flex-start'}
                direction='row'
                pl={'10px'}
                pr={'10px'}>
                    
                <Flex justifyContent='center' w='35%'>
                <Image
                    src={props.banner}
                    h='30px'
                />
                </Flex>
                <Flex justifyContent='center' w='65%'>
                <Text
                    fontWeight='700'
                    color={props.activate ? mainText : TextdisableColor}
                    textAlign='center'
                    fontSize='12px'>
                    {props.title}
                    </Text>
                </Flex>
            </Flex>
            </Box>
		    

             </Link> 
            {/* </NewWindow> */}
            {/* </OpenApp> */}
        </>
	);
}

export default MenuCard;